(function ($) {
	class W4D_Kupon {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$body = $('body');
			this.woocommerce = $('.woo-wrapper');
			this.cart = $('.cart');
			this.add_coupon = '.add_coupon';
			this.remove_coupon = '.remove_coupon';
			this.cartCollaterals = $('.cart__collaterals');
		}

		bindEvents() {
			$(document).on('click', this.add_coupon, (e) => this.dodajKupon(e));
			$(document).on('click', '.js-apply-specific-coupon', (e) => this.dodajKupon(e));
			$(document).on('click', this.remove_coupon, (e) => this.ukloniKupon($(e.currentTarget)));
			$(document).on('keydown', '#coupon_code', (e) => this.handleEnterPressOnCoupon(e));
		}

		handleEnterPressOnCoupon(e) {
			if (e.key === 'Enter') {
				e.preventDefault();
				$('#coupon_code').blur();
				this.dodajKupon(e);
			}
		}

		dodajKupon(e) {
			e.preventDefault();
			const $target = $(e.currentTarget);
			const rawCode = $target.data('coupon') || $('#coupon_code').val() || '';
			let couponCode = String(rawCode).trim();

			if (couponCode.length === 0) {
				return;
			}

			$.ajax({
				url: wc_add_to_cart_params.ajax_url,
				type: 'POST',
				data: {
					action: 'dodaj_promokod',
					nonce: window.w4d_frontend_ajax?.nonce || '',
					coupon_code: couponCode.trim(),
				},
				beforeSend: () => {
					this.cart.addClass('cart--loading');
					this.cartCollaterals.addClass('cart__collaterals--loading');
				},

				success: (response) => {
					if (response.success) {
						let message = response.data.message.replace(/<[^>]*>?/gm, '');
						W4D_Toast.showToast('success', message);

						// Check if data-summary-collapsed attribute exists before replacement
						const $cartSummary = $('.cart__summary');
						const $couponsHtml = $('.coupons');
						const wasCollapsed = $cartSummary.attr('data-summary-collapsed') !== undefined;

						if (response.data.cart_summary) {
							let newSummaryHtml = response.data.cart_summary;

							// If attribute WAS present (was collapsed), remove it from new HTML (force expand)
							if (wasCollapsed) {
								// Remove the entire data-summary-collapsed attribute from HTML string
								newSummaryHtml = newSummaryHtml.replace(
									/\s*data-summary-collapsed(?:\s*=\s*(?:["'][^"']*["']|[^\s>]*))?/gi,
									''
								);
							}

							// Replace element with modified HTML
							$cartSummary.replaceWith(newSummaryHtml);
							$couponsHtml.replaceWith(response.data.cart_coupons_html);
						}
					} else {
						$('#coupon-message').html('');
						if (response.data.tip === '1') {
							$('#coupon-message').html(response.data.message);
						} else {
							let message = response.data.message.replace(/<[^>]*>?/gm, '');
							W4D_Toast.showToast('error', message);
						}
					}
				},
				complete: () => {
					setTimeout(() => {
						this.cart.removeClass('cart--loading');
						this.cartCollaterals.removeClass('cart__collaterals--loading');
					}, 150);
				},
				error: (xhr, status, error) => {},
			});
		}

		ukloniKupon(e) {
			let couponCode = String(e.data('coupon'));
			if (couponCode.trim().length === 0) {
				W4D_Toast.showToast('error', 'couponCode is NullOrEmpty: {' + couponCode + '}');
				return;
			}

			$.ajax({
				url: wc_add_to_cart_params.ajax_url,
				type: 'POST',
				data: {
					action: 'ukloniKupon',
					nonce: window.w4d_frontend_ajax?.nonce || '',
					coupon_code: couponCode.trim(),
				},
				beforeSend: () => {
					this.cart.addClass('cart--loading');
					this.cartCollaterals.addClass('cart__collaterals--loading');
				},
				success: (response) => {
					if (response.success) {
						W4D_Toast.showToast('success', response.data.message);
						// Provjeri postoji li data-summary-collapsed atribut prije zamjene
						const $cartSummary = $('.cart__summary');
						const $couponsHtml = $('.coupons');
						const wasCollapsed = $cartSummary.attr('data-summary-collapsed') !== undefined;

						if (response.data.cart_summary) {
							let newSummaryHtml = response.data.cart_summary;

							// Ako PRET postojanja atributa, ukloni ga iz novog HTML-a
							if (!wasCollapsed) {
								// Ukloni cijeli data-summary-collapsed atribut iz HTML stringa
								newSummaryHtml = newSummaryHtml.replace(
									/data-summary-collapsed(?:\s*=\s*(?:["'][^"']*["']|[^>\s]*))?/gi,
									''
								);
							}

							// Zamijeni element s modificiranim HTML-om
							$cartSummary.replaceWith(newSummaryHtml);
							$couponsHtml.replaceWith(response.data.cart_coupons_html);
						}
					} else {
						W4D_Toast.showToast('error', response.data?.message || 'Došlo je do greške. Pokušajte ponovno.');
					}
				},
				complete: () => {
					setTimeout(() => {
						this.cart.removeClass('cart--loading');
						this.cartCollaterals.removeClass('cart__collaterals--loading');
					}, 150);
				},
				error: (xhr, status, error) => {},
			});
		}
	}

	$(document).ready(() => {
		window.W4D_Kupon = new W4D_Kupon();
	});
})(jQuery);
